export default {
  /*门店类别*/
  StoreType: [
    { id: 2, name: '采购商', textColor:'text-info',en:'travel' },
    { id: 3, name: '供应商', textColor:'text-blue',en:'hotel' },
    { id: 4, name: '导游', textColor:'text-warning',en:'tourguide' },
    // { id: 5, name: '民宿', textColor:'text-danger',en:'homestay' },
    // { id: 6, name: '景区', textColor:'text-success',en:'scenic' },
    // { id: 8, name: '品牌馆', textColor:'text-purple',en:'brand' },
    // { id: 99, name: '管理员',en:'admin' }
  ],
  StoreTypeStr: [
    {name:'管理员',id:'1'},
    {name:'采购商',id:'2'},
    {name:'酒店',id:'3'},
    {name:'导游',id:'4'},
    {name:'民宿',id:'5'},
    {name:'景区',id:'6'},
    {name:'品牌馆',id:'8'},
  ],
  StoreTypeSea: [
    {name:'全部',id:''},
    {name:'采购商',id:'2'},
    {name:'供应商',id:'3'},
    {name:'导游',id:'4'},
    // {name:'民宿',id:'5'},
    // {name:'景区',id:'6'},
    // {name:'品牌馆',id:'8'},
  ],
  StoreTypeGro: [
    {name:'全部',id:''},
    {name:'酒店',id:'3'},
    // {name:'民宿',id:'5'},
    // {name:'景区',id:'6'},
    {name:'采购商',id:'2'},
  ],
  StoreTypeGro: [
    {name:'全部',id:''},
    {name:'酒店',id:'3'},
    // {name:'民宿',id:'5'},
    // {name:'景区',id:'6'},
    {name:'采购商',id:'2'},
  ],
  AssociatedState: [
      {name:'全部',id:''},
      {name:'已加入',id:'1'},
      {name:'加入申请中',id:'2'},
      {name:'已拒绝',id:'3'},
      {name:'解除销售申请中',id:'4'},
      {name:'已解除销售',id:'5'},
  ],
  AssociatedStatecorl: [
    {name:'text-green',id:'1'},
    {name:'text-info',id:'2'},
    {name:'text-danger',id:'3'},
    {name:'text-warning',id:'4'},
    {name:'text-success',id:'5'},
  ],
}
